import React from "react";
import styles from "./Loader.module.scss";

type LoaderProps = {
  children?: React.ReactNode;
};

export const Loader = ({ children }: LoaderProps) => {
  return (
    <div className={styles["loader-wrapper"]}>
      <div className={styles["box-loader"]}>
        <div></div>
        <div></div>
        <div></div>
      </div>
      {children}
    </div>
  );
};
